export default __webpack_public_path__ + "static/media/no_photo.aa704206.jpg";